<template>
  <div style="position: absolute; top: 0; width: 100%; height: 100%; background: #f0f3f7">
    <div class="pc">
      <div class="head">
        <img class="img_12" style="" src="../../assets/listImgs/111.png" alt="" />
      </div>
      <div class="banner">
        <div class="left">
          <div style="text-align: center">
            <img class="box12" src="../../assets/listImgs/heiTitle.png" alt="" />
          </div>
          <div class="box13">
            <div
              @click="tabClcik(1)"
              :class="tabActive == '1' ? 'active' : 'noActive'"
              style="display: flex; justify-content: center; align-items: center"
            >
              <div class="box14" style="margin-top: 12px">
                <img v-if="tabActive == '1'" class="imgBox" src="../../assets/listImgs/myKao@2x.png" alt="" />
                <img class="imgBox" v-else src="../../assets/listImgs/nomy@2x.png" alt="" />
              </div>
              <div class="box14">我的考试</div>
            </div>

            <div @click="tabClcik(2)" :class="tabActive == '2' ? 'active box15' : 'noActive box15'">
              <div class="box14" style="margin-top: 12px">
                <img class="imgBox" v-if="tabActive == '2'" src="../../assets/listImgs/acjilu@2x.png" alt="" />
                <img v-else class="imgBox" src="../../assets/listImgs/jilu@2x.png" alt="" />
              </div>
              <div class="box14">考试记录</div>
            </div>

            <div @click="tabClcik(3)" :class="tabActive == '3' ? 'active box15' : 'noActive box15'">
              <div class="box14" style="margin-top: 12px">
                <img class="imgBox" v-if="tabActive == '3'" src="../../assets/listImgs/moB.png" alt="" />
                <img v-else class="imgBox" src="../../assets/listImgs/moh.png" alt="" />
              </div>
              <div class="box14">模拟考试</div>
            </div>
            <!-- <div class="noActive"
               style="display: flex; justify-content: center; align-items: center; margin-top: 20px">
            <div>
              <img style="margin-top: 6px"
                   class="imgBox"
                   src="../../assets/listImgs/tongzhi@2x.png"
                   alt="" />
            </div>
            <div style="margin-left: 5px">通知消息</div>
          </div> -->
          </div>
        </div>

        <div class="center">
          <div></div>
          <div class="center_left" v-if="tabActive == '1'">
            <div v-if="examList.length == 0" class="box16">暂无数据</div>
            <div v-else>
              <div v-for="(item, index) in examList" :key="item.id">
                <div
                  @click="tips(item, index)"
                  :class="active == index ? 'color1 tips' : 'color2 tips'"
                  v-if="item.status !== '03' && item.sta !== '04' && item.sta !== '03'"
                >
                  <div>
                    <!-- <div class="pos2"
                       v-if="item.sta == '01'">未开始</div>
                  <div class="pos4"
                       v-if="item.sta == '02'">进行中</div>
                  <div class="pos4"
                       v-if="item.sta == '03'">已结束</div> -->

                    <img :class="active == index ? 'img1' : 'img2'" :src="active == index ? xuan : nox" alt="" />

                    <div style="position: relative; z-index: 2; padding: 20px">
                      <div style="font-family: Medium" class="box17">
                        <div class="overText" :title="item.lrnExamQuiz.name">{{ item.lrnExamQuiz.name }}</div>
                        <div class="box18" :class="active == index ? 'color1' : 'color3'">
                          <div style="display: flex; align-items: center">
                            <div class="box19">
                              <img class="box20" src="../../assets/listImgs/xuxian@2x.png" alt="" />
                            </div>
                            <div class="box21" style="">{{ item.lrnExamQuiz.timeopen }}&emsp;&emsp;开始</div>
                          </div>

                          <div style="" class="box22">
                            <div class="box23"></div>
                            <div style="" class="box24">{{ item.lrnExamQuiz.timeclose }}&emsp;&emsp;结束</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="center_left" v-if="tabActive == '2'">
            <div v-if="examkList.length == 0" class="box16">暂无数据</div>
            <div v-else>
              <div
                @click="tips(item, index)"
                :class="active == index ? 'color1 tips' : 'tips color2'"
                v-for="(item, index) in examkList"
                :key="index"
              >
                <div v-if="item.state == '03'" class="pos2" style="background-color: #8793a4">已考完</div>
                <div v-if="item.state == '04'" class="pos2">批改中</div>
                <div v-if="item.state == '01'" class="pos2">考试中</div>
                <div v-if="item.state == '05'" class="pos2">已批改</div>
                <div v-if="item.state == '02'" class="pos2">已保存</div>
                <img :class="active == index ? 'img1' : 'img2'" :src="active == index ? xuan : nox" alt="" />
                <div class="box26">
                  <div class="box27">
                    <div class="overText" :title="item.quizName">{{ item.quizName }}</div>
                    <div class="box222">考试类型：{{ item.isMock == '01' ? '模拟考试' : '正式考试' }}</div>
                    <div class="box28">
                      <div v-if="item.isGrading == '02' && item.isMock == '02'">
                        <div :class="active == index ? 'color8' : 'color7'" style="font-size: 14px">考试成绩</div>
                        <div :class="item.qualified == '合格' ? 'color4 box29' : 'color6 box29'">{{ item.qualified }}</div>
                      </div>

                      <div
                        v-if="item.isGrading == '02' && item.isMock == '02'"
                        :class="item.qualified == '合格' ? 'color4 box30' : 'color6 box30'"
                        style=""
                      >
                        {{ item.grade }}分
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="center_left" v-if="tabActive == '3'">
            <div v-if="mockList.length == 0" class="box16">暂无数据</div>
            <div v-else>
              <div v-for="(item, index) in mockList" :key="item.id">
                <div @click="tips(item, index)" :class="active == index ? 'color1 tips' : 'color2 tips'" v-if="item.status !== '03'">
                  <div>
                    <div class="pos2" v-if="item.sta == '01'">未开始</div>
                    <div class="pos4" v-if="item.sta == '02'">进行中</div>
                    <div class="pos4" v-if="item.sta == '03'">已结束</div>

                    <img :class="active == index ? 'img1' : 'img2'" :src="active == index ? xuan : nox" alt="" />

                    <div style="position: relative; z-index: 2; padding: 20px">
                      <div style="font-family: Medium" class="box17">
                        <div class="overText" :title="item.lrnExamQuiz.name">{{ item.lrnExamQuiz.name }}</div>
                        <div class="box18" :class="active == index ? 'color1' : 'color3'">
                          <div style="display: flex; align-items: center">
                            <div class="box19">
                              <img class="box20" src="../../assets/listImgs/xuxian@2x.png" alt="" />
                            </div>
                            <div class="box21" style="">{{ item.lrnExamQuiz.timeopen }}&emsp;&emsp;开始</div>
                          </div>

                          <div style="" class="box22">
                            <div class="box23"></div>
                            <div style="" class="box24">{{ item.lrnExamQuiz.timeclose }}&emsp;&emsp;结束</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="deti" v-if="tabActive == '1'">
            <div v-if="examData.status !== '03' && examData.sta !== '04' && examData.sta !== '03'">
              <div class="soel">
                <img style="" class="box31" src="../../assets/listImgs/center_bc@2x.png" alt="" />
              </div>

              <div class="box32" style="font-family: Bold; color: #4275f5" v-if="examData.lrnExamQuiz">{{ examData.lrnExamQuiz.name }}</div>
              <div class="box34" v-if="examData.lrnExamQuiz">
                考试时间：{{ examData.lrnExamQuiz.timeopen }} — {{ examData.lrnExamQuiz.timeclose }}
              </div>
              <div class="box33" v-if="examData.lrnExamQuiz">考试时长：{{ examData.lrnExamQuiz.timelimit }}分钟</div>

              <div class="box33">考试题型：单选题, 多选题, 判断题, 简答题。</div>
              <div class="box33" style="display: flex">
                <div style="" class="ask">考试须知：</div>
                <div class="scolls">
                  <div v-if="examData.lrnExamQuiz" v-html="examData.lrnExamQuiz.description"></div>
                </div>
              </div>

              <!-- <div class="box33" style="color: red">请完成学习后方可参加考试</div> -->
              <!-- <el-button
            @click="exam"
            style="margin-top: 25px; color: #fff; width: 160px; height: 50px; border-radius: 25px; background: #d3d3d3"
          >
            考试咯
          </el-button> -->
              <!-- 正式考试的立即考试 -->
              <el-button @click="goExam(examData)" style="background: #507df7" class="box35"> 立即考试 </el-button>
            </div>
            <div v-else>暂无考试~</div>
            <!-- <el-button
            v-else
            disabled
            style="margin-top: 25px; color: #fff; width: 160px; height: 50px; border-radius: 25px;
background: #D3D3D3;"
          >
            未到考试时间
          </el-button> -->
          </div>

          <div class="deti" v-if="tabActive == '2'">
            <div class="soel">
              <img
                style="width: 150px; height: 120px; float: right; margin-top: 20px; margin-right: 20px"
                src="../../assets/listImgs/center_bc@2x.png"
                alt=""
              />
            </div>

            <div style="font-family: Bold; color: #4275f5" class="box32">{{ examData.quizName ? examData.quizName : '' }}</div>
            <div class="box34">考试时间：{{ examData.quizTime ? examData.quizTime : '' }}</div>
            <div class="box33">考试时长：{{ examData.timelimit ? examData.timelimit : '' }}分钟</div>
            <div class="box33">考试题型：单选题, 多选题, 判断题, 简答题。</div>
            <!-- <div class="box33">考试须知：</div> -->
            <!-- <div>{{ examData.quizduce  ? examData.quizduce : ''}}</div> -->
            <!-- <el-button
            @click="exam"
            style="margin-top: 25px; color: #fff; width: 160px; height: 50px; border-radius: 25px; background: #d3d3d3"
          >
            考试咯
          </el-button> -->

            <el-button @click="toPreview" class="box35" style="background: #4275f5"> 考卷回顾 </el-button>

            <!--          <el-button @click="zhengti"
                     style="background: #4275f5"
                     class="box35"> 在线征题 </el-button> -->
          </div>

          <div class="deti" v-if="tabActive == '3'">
            <div class="soel">
              <img
                style="width: 150px; height: 120px; float: right; margin-top: 20px; margin-right: 20px"
                src="../../assets/listImgs/center_bc@2x.png"
                alt=""
              />
            </div>

            <div style="font-family: Bold; color: #4275f5" class="box32">模拟考试</div>
            <div class="box34">考试时间：无</div>
            <div class="box33">考试时长：无</div>
            <div class="box33">考试题型：单选题, 多选题, 判断题, 简答题。</div>
            <!-- <div class="box33">考试须知：</div> -->
            <!-- <div>{{ examData.quizduce  ? examData.quizduce : ''}}</div> -->
            <!-- <el-button
            @click="exam"
            style="margin-top: 25px; color: #fff; width: 160px; height: 50px; border-radius: 25px; background: #d3d3d3"
          >
            考试咯
          </el-button> -->
            <!-- 模拟考试的立即考试 -->
            <el-button v-if="mockList.length !== 0" @click="goMoExam(examData)" style="background: #507df7" class="box35">
              立即考试
            </el-button>
          </div>
        </div>

        <div class="right">
          <div style="display: flex; justify-content: center">
            <div style="" class="box54">
              <img
                v-if="userData.userphoto !== null && userData.userphoto !== ''"
                style="width: 100%; height: 100%"
                :src="userData.userphoto"
                alt=""
              />
              <img v-else style="width: 100%; height: 100%" src="../../assets/img/userPhoto.png" alt="" />
            </div>
          </div>
          <div style="" class="box38">
            <div style="display: flex">
              <div>{{ userData.realname || '' }}</div>
              <div>
                <img v-if="userData.sex == '01'" class="box37" style="" src="../../assets/listImgs/nan@2x.png" alt="" />
                <img v-else class="box37" style="" src="../../assets/listImgs/nv@2x.png" alt="" />
              </div>
            </div>
          </div>

          <div class="box55"></div>

          <!--        <div style=""
             class="box39">
          <div style=""
               class="box40">
            <div style="display: flex">
              <img style=""
                   class="box41"
                   src="../../assets/listImgs/phone@2x.png"
                   alt="" />
              手机号码
            </div>
            <div class="box42"
                 style="">{{ userData.mobile }}</div>
          </div>
        </div>-->

          <div style="" class="box39">
            <div class="box40">
              <div style="display: flex">
                <img class="box41" src="../../assets/listImgs/cnCode@2x.png" alt="" />
                身份证号码
              </div>
              <div class="box42">{{ userData.cardno }}</div>
            </div>
          </div>

          <div class="box39">
            <div class="box40">
              <div style="display: flex">
                <!-- <img class="box41"
                   src="../../assets/listImgs/area@2x.png"
                   alt="" /> -->
                <!-- 所在地区 -->
              </div>
              <!-- <div class="box42">安徽省合肥市高新区创新产业园</div> -->
            </div>
          </div>

          <div class="box39">
            <div class="box40">
              <div style="display: flex">
                <!-- <img class="box41"
                   src="../../assets/listImgs/danwei@2x.png"
                   alt="" /> -->
                <!-- 单位名称 -->
              </div>
              <!-- <div class="box42">{{ userData.userAddress }}</div> -->
            </div>
          </div>

          <div class="shiX">
            <div style="" class="box43">注意事项</div>

            <div class="box44">请仔细核对个人信息，如信息有误需及时反馈，以免影响个人成绩证明!</div>
          </div>

          <div class="back" @click="logout">
            <div style="display: flex">
              <div><img class="box45" src="../../assets/listImgs/back@2x.png" alt="" /></div>
              <div style="" class="box46">退出登录</div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title="请选择考试" :visible.sync="mockListVisible" width="30%">
        <div class="mo">
          <div class="listbox1" v-for="item in mockSeletList" :key="item.ID" @click="goExam(item)">
            {{ item.NAME }}
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="mockListVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- <div v-if="dialogVisible"
         style=""
         class="box47">


    </div> -->
    </div>
    <el-dialog :visible.sync="dialogVisible" :width="widthOuto" top="2vh">
      <div style="font-family: Medium">
        <div class="box49" style="">承诺书</div>
        <div style="" class="box50">
          <div v-if="cnsContent !== null">
            <div class="ql-container ql-snow">
              <div class="ql-editor" style="font-family: Medium" v-html="cnsContent"></div>
            </div>
            <div v-if="checked" style="text-align: right; font-weight: bold">签署人： {{ userData.realname || '' }}</div>
          </div>

          <div v-else>
            <div style="text-align: center">暂无内容</div>
          </div>
        </div>
        <el-checkbox class="box36" v-model="checked">我已仔细阅读承诺书，并同意</el-checkbox>
        <div @click="queKs" class="qBtn">同意并立即考试</div>
      </div>
    </el-dialog>
    <div class="phone">
      <div class="headP">
        {{ textPhone }}

        <div class="logOutBpx" @click="phoneLogout">退出登录</div>
      </div>
      <div class="banner_phone" v-if="navBottom == 1">
        <div class="phoneTips" v-if="PhoneExamList.length == 0">暂无考试数据 ~</div>
        <div v-else>
          <div v-for="item in PhoneExamList" :key="item.id">
            <div class="list_phoneBox" v-if="item.status !== '03' && item.sta !== '04' && item.sta !== '03'">
              <div class="titl">
                <!-- <div class="color_box">专业课</div> -->
                <div class="name_phone">{{ item.lrnExamQuiz.name }}</div>
              </div>

              <div class="timeB_phone">
                <div class="left_phone">
                  <div class="yuan" style="background: #5ad068"></div>
                  <div class="ssw">
                    <img class="xuImg" src="../../assets/listImgs/phoneXuxian.png" alt="" />
                  </div>
                  <div class="yuan" style="background: #fe5f5e"></div>
                </div>

                <div class="text_phone">
                  <div class="ccr1">开始：{{ item.lrnExamQuiz.timeopen }}</div>
                  <div>结束：{{ item.lrnExamQuiz.timeclose }}</div>
                </div>
              </div>

              <div class="border"></div>

              <div class="botom_phone">
                <div class="text_btnw"></div>

                <div style="display: flex">
                  <div class="btn_pnne" @click="goPhoneMoExam(item)">参与考试</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner_phone" v-if="navBottom == 2">
        <div class="phoneTips" v-if="phoneMoList.length == 0">暂无模拟考试 ~</div>
        <div v-else>
          <div v-for="item in phoneMoList" :key="item.id">
            <div class="list_phoneBox">
              <div class="titl">
                <!-- <div class="color_box">专业课</div> -->
                <div class="name_phone">{{ item.lrnExamQuiz.name }}</div>
              </div>

              <div class="timeB_phone">
                <div class="left_phone">
                  <div class="yuan" style="background: #5ad068"></div>
                  <div class="ssw">
                    <img class="xuImg" src="../../assets/listImgs/phoneXuxian.png" alt="" />
                  </div>
                  <div class="yuan" style="background: #fe5f5e"></div>
                </div>

                <div class="text_phone">
                  <div class="ccr1">开始：{{ item.lrnExamQuiz.timeopen }}</div>
                  <div>结束：{{ item.lrnExamQuiz.timeclose }}</div>
                </div>
              </div>

              <div class="border"></div>

              <div class="botom_phone">
                <div class="text_btnw"></div>

                <div style="display: flex">
                  <div class="btn_pnne" @click="goPhoneMoExam(item, '1')">参与考试</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner_phone" v-if="navBottom == 3">
        <div class="phoneTips" v-if="examkList.length == 0">暂无考试记录 ~</div>
        <div v-else>
          <div v-for="(item, index) in examkList" :key="item.id">
            <div class="list_phoneBox">
              <div class="titl">
                <!-- <div class="color_box">专业课</div> -->
                <div class="name_phone">{{ item.quizName }}</div>
              </div>

              <div class="border"></div>
              <div class="sk">
                <div v-if="item.state == '03'" class="pos2" style="color: #8793a4">已考完</div>
                <div v-if="item.state == '04'" class="pos2">批改中</div>
                <div v-if="item.state == '01'" class="pos2">考试中</div>
                <div v-if="item.state == '05'" class="pos2">已批改</div>
                <div v-if="item.state == '02'" class="pos2">已保存</div>
              </div>
              <div class="box26">
                <div class="box27">
                  <div class="box222">考试类型：{{ item.isMock == '01' ? '模拟考试' : '正式考试' }}</div>
                  <div class="box28">
                    <div v-if="item.isGrading == '02' && item.isMock == '02'">
                      <div style="font-size: 14px">考试成绩</div>
                      <div :class="item.qualified == '合格' ? 'color4 box29' : 'color6 box29'">{{ item.qualified }}</div>
                    </div>

                    <div
                      v-if="item.isGrading == '02' && item.isMock == '02'"
                      :class="item.qualified == '合格' ? 'color4 box30' : 'color6 box30'"
                      style=""
                    >
                      {{ item.grade }}分
                    </div>
                  </div>
                </div>
              </div>
              <div class="botom_phone">
                <div class="text_btnw"></div>

                <div style="display: flex">
                  <div class="xq_btn" @click="phoneToPreview(index)">查看考卷</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="navBox">
        <div @click="navBar(2)">
          <div>
            <div class="imgbox" style="position: relative">
              <img class="imgNav" v-if="navBottom !== 2" :src="moni" alt="" />
              <img class="imgNav" v-if="navBottom == 2" :src="hasMoni" alt="" />
            </div>
            <div :class="navBottom == 2 ? 'text' : 'text active'">模拟考试</div>
          </div>
        </div>
        <div @click="navBar(1)">
          <div>
            <div class="imgbox" style="position: relative">
              <img class="imgNav" v-if="navBottom == 1" :src="hasExam" alt="" />
              <img class="imgNav" v-if="navBottom !== 1" :src="noExam" alt="" />
            </div>
            <div :class="navBottom == 1 ? 'text ' : 'text active'">我的考试</div>
          </div>
        </div>
        <div @click="navBar(3)">
          <div>
            <div class="imgbox" style="position: relative">
              <img class="imgNav" v-if="navBottom !== 3" :src="noJl" alt="" />
              <img class="imgNav" v-if="navBottom == 3" :src="hasJl" alt="" />
            </div>
            <div :class="navBottom == 3 ? 'text' : 'text active'">考试记录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import nox from '../../assets/listImgs/nox@2x.png';
import xuan from '../../assets/listImgs/xuanzhong@2x.png';
import hasExam from '../../assets/listImgs/myMock@2x.png';
import noJl from '../../assets/listImgs/myJilu@2x.png';
import noExam from '../../assets/listImgs/noExam@2x.png';
import hasJl from '../../assets/listImgs/hasJl@2x.png';
import moni from '../../assets/listImgs/1mnMock.png';
import hasMoni from '../../assets/listImgs/mnMoke.png';
import { mapMutations } from 'vuex';
import { toExamQuize, toExamUQDetail, logout, toPreview, findUQState, doLogin, mockList, examQuizList } from '../../api/index';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      textPhone: '刷题系统',
      PhoneExamList: [],
      navBottom: 2, //切换
      active: 0,
      nox,
      xuan,
      hasExam,
      noJl,
      noExam,
      hasJl,
      moni,
      hasMoni,
      dialogVisible: false, //承诺书弹框
      tabActive: '',
      examList: [], //我的考试列表
      userData: {}, //用户数据
      examkList: [''], //试卷列表
      examData: {}, //考试数据
      url: '', //在线征题的url
      mockListVisible: false,
      surl: '',
      webSocket: null, //
      checked: false, //承诺书勾选
      mockList: [], //模拟考试列表
      mockSeletList: [], //分类列表
      mockActive: null,
      moUqid: '', //模拟考试id
      cnsContent: '',
      mockIds: '', //考试id
      widthOuto: '30%',
      isMobile: null, //是否是移动端
      mobileId: '',
      phoneMoList: [], //模拟考试
      examFalg: false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken']),
    navBar(id) {
      this.navBottom = id;
      if (id == 3) {
        this.textPhone = '考试记录';
        toExamUQDetail({}).then(res => {
          this.examkList = res.data.data.examUQDetailList;
          console.log(res);
          this.url = res.data.data.url;
          this.tips(this.examkList[0], 0);
        });
      } else if (id == 1) {
        this.getExamList();
        this.textPhone = '刷题系统';
      } else {
        //获取模拟考试列表
        this.phoneMoList = [];
        toExamQuize({}).then(res => {
          if (res.data.data.examMockList.length == 0) {
            console.log(this.phoneMoList);
            return false;
          }
          res.data.data.examMockList.forEach(element => {
            if (element.status !== '03' && element.sta !== '04' && element.sta !== '03') {
              this.phoneMoList.push(element);
            }
          });
        });
      }
    },
    goCode(item, id) {
      this.mockActive = id;
      let query = {
        codeNo: item.codeNo,
        pageNum: 1,
        pageSize: 999999
      };
      examQuizList(query).then(res => {
        console.log(res);
        this.mockSeletList = res.data.data;
        this.mockListVisible = true;
      });
    },
    //登录
    login(data) {
      doLogin(data).then(res => {
        ////console.log(res);
        if (res.data.token) {
          this.updateToken(res.data.token);
          //拿到密钥存在本地存储
          localStorage.setItem('token', res.data.token);

          this.tabClcik(1);
          this.getExamList();
        }
      });
    },
    //跳后台在线征题页面
    zhengti() {
      window.open(this.url);
    },
    phoneToPreview(id) {
      console.log(id);
      if (this.examkList[id] == undefined) {
        this.$message('未选择试卷！');
        return false;
      }
      this.dialogVisible = false;
      console.log(id);
      this.$router.push({
        path: '/record',
        query: {
          id: this.examkList[id].uqdId
        }
      });
      // let data = {
      //   uqdId:this.examkList[this.active].uqdId
      // }
      // toPreview(data).then(res => {
      //   console.log(res);
      // })
    },
    //考卷回顾
    toPreview() {
      console.log(this.examkList[this.active]);
      if (this.examkList[this.active] == undefined) {
        this.$message('未选择试卷！');
        return false;
      }
      this.dialogVisible = false;
      console.log(this.active);
      this.$router.push({
        path: '/record',
        query: {
          id: this.examkList[this.active].uqdId
        }
      });
      // let data = {
      //   uqdId:this.examkList[this.active].uqdId
      // }
      // toPreview(data).then(res => {
      //   console.log(res);
      // })
    },
    phoneLogout() {
      logout().then(res => {
        console.log(res);
      });
      this.$router.push('/');
      this.$message({
        type: 'success',
        message: '退出成功!'
      });
    },
    //退出登录
    logout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logout().then(res => {
            console.log(res);
          });
          this.$router.push('/');
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    //获取考试列表
    getExamList() {
      let _this = this;
      _this.PhoneExamList = [];
      toExamQuize({}).then(res => {
        _this.examList = res.data.data.examUqList;
        _this.userData = res.data.data.user;
        _this.tips(this.examList[0], 0);
        res.data.data.examUqList.forEach(element => {
          if (element.status !== '03' && element.sta !== '04' && element.sta !== '03') {
            _this.PhoneExamList.push(element);
          }
        });
        if (res.data.data.examMockList.length == 0) {
          console.log(this.phoneMoList);
          return false;
        }
        res.data.data.examMockList.forEach(element => {
          if (element.status !== '03' && element.sta !== '04' && element.sta !== '03') {
            this.phoneMoList.push(element);
          }
        });
        _this.mockList = res.data.data.examMockList;
        
        console.log( _this.userData);
       
      });
    },
    //tab栏
    tabClcik(id) {
      console.log(id);
      this.tabActive = id;
      if (id == 2) {
        toExamUQDetail({}).then(res => {
          console.log(res);
          this.examkList = res.data.data.examUQDetailList;
          this.url = res.data.data.url;
          this.tips(this.examkList[0], 0);
        });
      } else if (id == 1) {
        this.tips(this.examList[0], 0);
      } else {
        if (this.mockList.length !== 0) {
          this.moUqid = this.mockList[0].id;
        }
        this.examData = '';
      }
    },
    tips(item, idx) {
      this.active = idx;
      if (item !== undefined) {
        this.examData = item;
        console.log(this.examData);
      }
    },
    //模拟考试
    goPhoneMoExam(item, id) {
      console.log(item);
      if (id == 1) {
        this.$router.push({
          path: '/questions',
          query: {
            id: item.id,
            type: 'mo'
          }
        });
      } else {
        if (this.examFalg) {
          return false;
        }
        this.examFalg = true;
        findUQState({ uqId: item.id }).then(res => {
          console.log(res);
          //张鸿亮对接字段
          if (res.data.data.sta == '01') {
            //陈龙对接字段承诺书
            this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (this.isMobile) {
              this.$router.push({
                path: '/questions',
                query: {
                  id: item.id
                }
              });
              // this.mobileId = item.id;
              // this.widthOuto = '90%';
              // if (res.data.data.isCheck == 1) {
              //   this.$router.push({
              //     path: '/questions',
              //     query: {
              //       id: item.id
              //     }
              //   });
              //   return false;
              // }
            }
            // this.dialogVisible = true;
            // this.cnsContent = res.data.data.commitment;
          } else {
            this.$message({
              type: 'warning',
              message: '您无法参加该考试！',
              offset: '300',
              center: true
            });
            setTimeout(() => {
              this.examFalg = false;
            }, 3000);
            // this.getExamList();
          }
        });
      }
    },
    //模拟考试
    goMoExam(item) {
      if (item) {
        this.moUqid = item.id;
        console.log(this.moUqid, 1);
        findUQState({ uqId: this.moUqid }).then(res => {
          console.log(res);
          if (res.data.data.sta == '01') {
            this.$router.push({
              path: '/questions',
              query: {
                id: this.mockList[this.active].id,
                type: 'mo'
              }
            });
          }
        });
      } else {
        console.log(this.moUqid, 2);
        findUQState({ uqId: this.moUqid }).then(res => {
          console.log(res);
          if (res.data.data.sta == '01') {
            this.$router.push({
              path: '/questions',
              query: {
                id: this.mockList[this.active].id,
                type: 'mo'
              }
            });
          }
        });
      }
    },
    queKs() {
      if (this.isMobile) {
        this.$router.push({
          path: '/questions',
          query: {
            id: this.mobileId
          }
        });
      } else {
        this.$router.push({
          path: '/questions',
          query: {
            id: this.examList[this.active].id
          }
        });
      }
    },
    //参加考试
    goExam(item) {
      this.mockIds = item.quizId;
      findUQState({ uqId: item.id }).then(res => {
        console.log(res);
        //张鸿亮对接字段
        if (res.data.data.sta == '01') {
          this.mobileId = item.id;
          //陈龙对接字段承诺书
          this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          if (this.isMobile) {
            this.$router.push({
              path: '/questions',
              query: {
                id: this.mobileId
              }
            });
          } else {
            this.$router.push({
              path: '/questions',
              query: {
                id: this.examList[this.active].id
              }
            });
          }
        } else {
          this.$message({
            type: 'info',
            message: '您无法参加该考试！'
          });
          this.getExamList();
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.$route.query.userNames);

    if (this.$route.query.userNames) {
      let data = {
        userName: this.$route.query.userNames, //用户名
        userPasswd: '123456' //密码
      };
      this.login(data);
    } else {
      if (this.$route.query.table) {
        this.tabClcik(2);
      } else {
        this.tabClcik(1);
      }
      this.getExamList();
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener(
      'storage',
      () => {
        this.$confirm('禁止打开多标签页！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false,
          distinguishCancelAndClose: true,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(() => {
            window.open('about:blank', '_self');
            window.close();
          })
          .catch(() => {});
      },
      false
    );
    localStorage.setItem('Sentinel', Math.random());
  },
  destroyed() {
    // this.webSocket.close();
  },
  beforeCreate() {
    // this.webSocket.close();
  }, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
@media (min-width: 768px) {
  .phone {
    display: none;
  }
  .img_12 {
    width: 144px;
    height: 25px;
  }
  .mo {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .listbox1 {
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      border: 1px solid #4275f5;
      color: #4275f5;
      border-radius: 8px;
      margin: 5px 0;
    }
  }
  .box12 {
    width: 144px;
    height: 25px;
  }
  .box13 {
    margin-top: 30px;
  }
  .box14 {
    margin-left: 5px;
    margin-top: 6px;
  }
  .box15 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
  .box16 {
    text-align: center;
    font-size: 17px;
    font-family: Medium;
    line-height: 700px;
  }
  .box17 {
    font-size: 16px;
  }
  .box18 {
    margin-top: 15px;
  }
  .box222 {
    margin-top: 8px;
    font-size: 14px !important;
  }
  .listbox1 {
    height: 40px;
    padding: 0 20px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #4275f5;
    color: #4275f5;
    border-radius: 8px;
    margin: 0 5px 5px 0;
  }
  .listbox1:hover {
    background: #4275f5;
    color: #fff;
  }
  .listbox1Active {
    background: #4275f5;
    color: #fff;
  }
  .box19 {
    position: relative;
    width: 9px;
    height: 9px;
    background: #5ad068;
    border-radius: 50%;
  }
  .box20 {
    width: 1px;
    height: 13px;
    position: absolute;
    bottom: -17px;
    left: 4px;
  }
  .box21 {
    margin-left: 5px;
    font-family: Regular;
  }
  .box22 {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }
  .box23 {
    width: 9px;
    height: 9px;
    background: #fe5f5e;
    border-radius: 50%;
  }

  .box24 {
    margin-left: 5px;
    font-family: Regular;
  }
  .box25 {
    width: 9px;
    height: 9px;
    background: #fe5f5e;
    border-radius: 50%;
  }
  .box26 {
    position: relative;
    z-index: 2;
    padding: 20px;
  }

  .overText {
    width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .box27 {
    font-size: 16px;
    font-family: Medium;
  }

  .box28 {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
  }
  .box29 {
    font-size: 14px;
    margin-top: 8px;
  }
  .box30 {
    font-family: Bold;
    font-size: 26px;
    margin-top: 8px;
  }
  .box31 {
    width: 150px;
    height: 120px;
    float: right;
    margin-top: 20px;
    margin-right: 20px;
  }
  .box32 {
    font-size: 20px;
  }
  .box33 {
    margin-top: 8px;
  }
  .ask {
    width: 71px;
  }
  .scolls {
    width: 720px;
    max-height: 450px;
    overflow-y: scroll;
  }
  .center_left {
    overflow-x: hidden;
  }
  .scolls {
    padding: 0 5px;
    overflow-x: hidden;
  }
  .scolls::-webkit-scrollbar {
    width: 4px;
  }
  .scolls::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
  }
  .scolls::-webkit-scrollbar-track {
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  .box34 {
    margin-top: 12px;
  }
  .box35 {
    margin-top: 25px;
    color: #fff;
    width: 160px;
    height: 50px;
    border-radius: 25px;
  }
  .box36 {
    margin-top: 12px;
  }
  .box37 {
    width: 72px;
    height: 72px;
    box-shadow: 0px 4px 15px #e5e5e5;
    border-radius: 50%;
    overflow: hidden;
  }
  .box38 {
    margin-top: 15px;
    font-size: 18px;
    display: flex;
    justify-content: center;
  }
  .box36 {
    margin-top: 12px;
  }
  .box37 {
    width: 24px;
    height: 18px;
    margin-left: 4px;
    margin-top: 3px;
  }

  .box39 {
    margin-top: 29px;
  }
  .box40 {
    font-size: 16px;
    color: #272748;
  }
  .box41 {
    width: 16px;
    height: 16px;
    margin-top: 4px;
    margin-right: 4px;
  }
  .box42 {
    color: #8793a4;
    font-size: 14px;
    font-family: Regular;
    margin-top: 3px;
  }
  .box43 {
    font-size: 14px;
    text-align: center;
  }
  .box44 {
    margin-top: 10px;
  }
  .box45 {
    width: 16px;
    height: 16px;
    margin-top: 17px;
  }
  .box46 {
    margin-left: 8px;
  }
  .box47 {
    position: absolute;
    top: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
  }
  .box48 {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }
  .box49 {
    text-align: center;
    font-size: 18px;
    font-family: Bold;
  }
  .box50 {
    margin-top: 20px;
  }
  .box51 {
    margin-left: 8px;
  }
  .box52 {
    margin-left: 8px;
  }
  .box53 {
    margin-left: 8px;
  }
  .box54 {
    width: 72px;
    height: 72px;
    box-shadow: 0px 4px 15px #e5e5e5;
    border-radius: 50%;
    opacity: 1;
    overflow: hidden;
  }
  .box55 {
    width: 100%;
    height: 1px;
    background: #eee;
    margin-top: 28px;
  }

  .imgBox {
    width: 16px;
    height: 16px;
  }
  .active {
    width: 200px;
    height: 52px;
    background: #4275f5;
    opacity: 1;
    border-radius: 12px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
  }
  .noActive {
    width: 200px;
    height: 52px;
    background: #fff;
    opacity: 1;
    border-radius: 12px;
    color: #8793a4;
    font-size: 16px;
    cursor: pointer;
  }
  .dia {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    font-size: 16px;
    font-family: Regular;
  }
  .qBtn {
    width: 180px;
    height: 50px;
    background: #4275f5;
    opacity: 1;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    line-height: 50px;
    margin: 23px auto auto auto;
  }
  .head {
    width: 100%;
    height: 60px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('../../assets/listImgs/head_bc@2x.png') 100% 100%;
  }
  .banner {
    margin-top: 15px;
    display: flex;
    padding: 0 100px;
    .left {
      width: 240px;
      height: 800px;
      background: #ffffff;
      opacity: 1;
      border-radius: 12px;
      padding: 30px 20px;
      font-family: Medium;
    }
    .center {
      width: 1220px;
      height: 800px;
      background: #fff;
      opacity: 1;
      border-radius: 12px;
      margin-left: 10px;
      display: flex;
      .center_left {
        padding: 10px 0 0 20px;
        height: 800px;
        width: 410px;
        overflow-y: scroll;
        .tips {
          width: 350px;
          height: 126px;
          margin-top: 20px;
          position: relative;

          cursor: pointer;
        }
        .color1 {
          color: #4275f5;
        }
        .color2 {
          color: #333333;
        }
        .color3 {
          color: #8793a4;
        }
        .img1 {
          width: 357px;
          height: 126px;
          position: absolute;
          top: 0;
          z-index: 1;
        }
        .img2 {
          width: 350px;
          height: 126px;
          position: absolute;
          top: 0;
          z-index: 1;
        }
        .pos2 {
          position: absolute;
          top: 1px;
          right: 0px;
          z-index: 2;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          width: 64px;
          height: 24px;
          background: #5ad068;
          border-radius: 0px 12px 0px 12px;
        }

        .pos4 {
          position: absolute;
          top: 1px;
          right: 0px;
          z-index: 2;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          width: 64px;
          height: 24px;
          background: #4275f5;
          border-radius: 0px 12px 0px 12px;
        }
      }
      .center_left::-webkit-scrollbar {
        width: 4px;
      }
      .center_left::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.2);
      }
      .center_left::-webkit-scrollbar-track {
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }

      .deti {
        margin-left: 30px;
        padding: 30px 20px 0 0;
        font-family: Medium;
        color: #272748;
        font-size: 14px;
        position: relative;
        z-index: 2;
        width: 820px;
        .soel {
          width: 100%;
          position: absolute;
          top: 0;
          height: 156px;
          border-radius: 12px;
          z-index: -1;
          background: linear-gradient(187deg, #dde6ff 0%, #ffffff 39%);
        }
      }
    }
    .right {
      width: 240px;
      height: 800px;
      background: #ffffff;
      border-radius: 12px;
      margin-left: 10px;
      padding: 30px 20px;
      font-family: Medium;
      color: #272748;

      .shiX {
        margin-top: 70px;
        width: 200px;
        height: 125px;
        background: rgba(254, 95, 94, 0.08);
        border-radius: 12px;
        padding: 20px;
        color: #fe5f5e;
        font-size: 12px;
      }
      .back {
        width: 160px;
        height: 50px;
        border: 1px solid #fe5f5e;
        border-radius: 12px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        color: #fe5f5e;
        display: flex;
        cursor: pointer;
        justify-content: center;
        margin-left: 20px;
        margin-top: 40px;
      }
    }
  }
  .color4 {
    color: #5ad068;
  }
  .color5 {
    color: #fff;
  }

  .color6 {
    color: #fe5f5e;
  }
  .color7 {
    color: #8793a4;
  }
  .color8 {
    color: #4275f5;
  }

  .faceCamera {
    background: gray;
    margin: 0 auto;
    border-radius: 4px;
    overflow: hidden;
    -webkit-border-radius: 4px;
    left: 0;
    top: -8.5%;
    right: 0;
    bottom: 0;
    padding-top: 50px;
    display: none;
    position: fixed;
    z-index: 999999999;
    text-align: center;
    width: 93%;
    height: 530px;
    margin-top: 65px;
  }
}

//移动
@media (max-width: 768px) {
  .phoneTips {
    text-align: center;
    font-size: 16px;
    margin-top: 50px;
  }
  .box49 {
    text-align: center;
    font-size: 18px;
    font-family: Bold;
  }
  .qBtn {
    width: 180px;
    height: 50px;
    background: #4275f5;
    opacity: 1;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    line-height: 50px;
    margin: 23px auto auto auto;
  }
  .pc {
    display: none;
  }
  .phone {
    font-family: Medium;
    position: relative;
    .navBox {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 51px;
      background: #fff;
      padding: 5px 35px;
      display: flex;
      justify-content: space-between;
      .imgbox {
        display: flex;
        justify-content: center;
        height: 25px;
      }
      .imgNav {
        width: 25px;
        height: 25px;
      }
      .text {
        font-size: 11px;
      }
      .active {
        color: #bcc1c7;
      }
    }
  }
  .headP {
    position: relative;
    width: 100%;
    height: 44px;
    font-size: 17px;
    text-align: center;
    background: #fff;
    line-height: 44px;
    .logOutBpx {
      height: 30px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      color: #fff;
      line-height: 30px;
      font-size: 15px;
      padding: 0 10px;
      border-radius: 5px;
      background: #4275f5;
    }
  }
  .banner_phone {
    padding: 10px 15px;
    background: rgb(240, 243, 247);
    padding-bottom: 50px;
    .list_phoneBox {
      width: 100%;
      min-height: 171px;
      background: #fff;
      border-radius: 8px;
      padding: 16px 14px 12px 14px;
      margin-bottom: 10px;
      .titl {
        font-size: 16px;
        color: #333333;
        display: flex;
        .color_box {
          width: 43px;
          height: 19px;
          background: #4275f5;
          border-radius: 4px;
          font-size: 11px;
          text-align: center;
          color: #ffffff;
          line-height: 19px;
          margin-top: 2px;
        }
        .name_phone {
          flex: 1;
          margin-left: 6px;
        }
      }
      .timeB_phone {
        display: flex;
        margin-top: 11px;
        .left_phone {
          margin-top: 6px;
        }
        .x_phone {
          height: 30px;
        }
        .ssw {
          position: relative;
          width: 2px;
          height: 17px;
          margin: 3px 0;
          .xuImg {
            position: absolute;
            top: 0;
            left: 2px;
            width: 2px;
            height: 17px;
          }
        }

        .yuan {
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }

        .text_phone {
          font-weight: 400;
          font-size: 13px;
          color: #666666;
          margin-left: 7px;
          .ccr1 {
            margin-bottom: 9px;
          }
        }
      }
      .box222 {
        margin-top: 8px;
        font-size: 14px !important;
      }
      .color4 {
        color: #5ad068;
      }
      .box29 {
        font-size: 14px;
        margin-top: 8px;
      }
      .box30 {
        font-family: Bold;
        font-size: 16px;
        margin-top: 8px;
      }
      .pos2 {
        font-size: 12px;
        color: #fff;
      }
      .color7 {
        color: #8793a4;
      }
      .color8 {
        color: #4275f5;
      }
      .sk {
        margin-top: 10px;
      }
      .border {
        margin-top: 14px;
        width: 100%;
        height: 1px;
        background: #eeeeee;
      }

      .botom_phone {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
        .text_btnw {
          font-size: 13px;
          margin-top: 8px;
        }
        .xq_btn {
          width: 88px;
          height: 35px;
          border-radius: 6px;
          border: 1px solid #666666;
          font-size: 13px;
          color: #666666;
          text-align: center;
          line-height: 35px;
          margin-right: 14px;
        }
        .btn_pnne {
          width: 88px;
          height: 35px;
          background: rgba(66, 117, 245, 0.15);
          border-radius: 6px;
          color: #4275f5;
          font-size: 13px;
          text-align: center;
          line-height: 35px;
        }
      }
    }
  }
}
</style>
